export default __webpack_public_path__ + "static/media/failed.a28fd1cc.png";